import {ICellRendererParams} from '../types/AgGridTypes';
import {getUnformattedValue} from './getUnformattedValue';

export const getValueToRender = (cellRendererProps: ICellRendererParams) => {
  const {formatValue} = cellRendererProps;
  const unformatted = getUnformattedValue(cellRendererProps);
  return formatValue ? formatValue(unformatted) : unformatted;
};
